import React from 'react';
import PropTypes from 'prop-types';
import { LuCircleCheck, LuCircleDashed, LuLoaderCircle, LuTriangleAlert } from 'react-icons/lu';
import Badge from '../../../../components/ui/Badge';
import useEducationReportText from '../educationReportText';

export const STATUS_META = {
  completed: { tone: 'success', icon: LuCircleCheck, gradient: 'tw-from-emerald-400 tw-to-teal-600 tw-shadow-emerald-500/30', bar: 'tw-bg-gradient-to-r tw-from-emerald-400 tw-to-teal-500' },
  inProgress: { tone: 'warning', icon: LuLoaderCircle, gradient: 'tw-from-amber-400 tw-to-orange-500 tw-shadow-amber-500/30', bar: 'tw-bg-gradient-to-r tw-from-amber-300 tw-to-orange-500' },
  notStarted: { tone: 'neutral', icon: LuCircleDashed, gradient: 'tw-from-slate-400 tw-to-slate-600 tw-shadow-slate-500/30', bar: 'tw-bg-slate-300 dark:tw-bg-white/20' },
};

export const initialsOf = (row) =>
  `${(row.eName || '').charAt(0)}${(row.eSurname || '').charAt(0)}`.toLocaleUpperCase('tr-TR') || '?';

export const StatusBadge = ({ status }) => {
  const { statusLabel } = useEducationReportText();
  const meta = STATUS_META[status] || STATUS_META.notStarted;
  const Icon = meta.icon;
  return (
    <Badge tone={meta.tone}>
      <Icon aria-hidden="true" className="tw-h-3 tw-w-3" />
      {statusLabel(status)}
    </Badge>
  );
};

StatusBadge.propTypes = { status: PropTypes.string.isRequired };

/** Completion bar with "done/total" and the percentage. */
export const ProgressBar = ({ done, total, status, compact }) => {
  const percent = total > 0 ? Math.round((done / total) * 100) : 0;
  const meta = STATUS_META[status] || STATUS_META.notStarted;
  return (
    <span className="tw-flex tw-min-w-0 tw-items-center tw-gap-2">
      <span className={`tw-block tw-h-2 tw-min-w-0 tw-flex-1 tw-overflow-hidden tw-rounded-full tw-bg-slate-200/80 dark:tw-bg-white/10 ${compact ? 'tw-max-w-[8rem]' : ''}`}>
        <span className={`tw-block tw-h-full tw-rounded-full ${meta.bar}`} style={{ width: `${percent}%` }} />
      </span>
      <span className="tw-shrink-0 tw-text-xs tw-font-semibold tw-tabular-nums tw-text-slate-600 dark:tw-text-slate-300">
        {done}/{total} · %{percent}
      </span>
    </span>
  );
};

ProgressBar.propTypes = { done: PropTypes.number.isRequired, total: PropTypes.number.isRequired, status: PropTypes.string, compact: PropTypes.bool };

export const OverdueCount = ({ count }) => (count > 0 ? (
  <Badge tone="danger">
    <LuTriangleAlert aria-hidden="true" className="tw-h-3 tw-w-3" />
    {count}
  </Badge>
) : <span className="tw-text-slate-400 dark:tw-text-slate-500">-</span>);

OverdueCount.propTypes = { count: PropTypes.number.isRequired };
